export interface CommandContext {
  split(): void;
  deleteSelection(ripple?: boolean): void;
  duplicate(): void;
  addMarker(): void;
  addText(): void;
  addShape(): void;
  addScene3D(): void;
  togglePlayback(): void;
  toggleSnapping(): void;
  setWorkspace(workspace: 'video' | 'motion' | '3d' | 'audio'): void;
  undo(): void;
  redo(): void;
  showExport(): void;
  showImport(): void;
}

export interface EditorCommand {
  id: string;
  label: string;
  category: string;
  shortcut?: string;
  keywords?: string;
  run(context: CommandContext): void;
}

export const commands: EditorCommand[] = [
  { id: 'edit.split', label: 'Split clip at playhead', category: 'Edit', shortcut: 'S', keywords: 'cut razor', run: (c) => c.split() },
  { id: 'edit.delete', label: 'Delete selection', category: 'Edit', shortcut: 'Delete', run: (c) => c.deleteSelection() },
  { id: 'edit.ripple-delete', label: 'Ripple delete selection', category: 'Edit', shortcut: 'Shift+Delete', run: (c) => c.deleteSelection(true) },
  { id: 'edit.duplicate', label: 'Duplicate selection', category: 'Edit', shortcut: 'Ctrl+D', run: (c) => c.duplicate() },
  { id: 'edit.undo', label: 'Undo', category: 'Edit', shortcut: 'Ctrl+Z', run: (c) => c.undo() },
  { id: 'edit.redo', label: 'Redo', category: 'Edit', shortcut: 'Ctrl+Shift+Z', run: (c) => c.redo() },
  { id: 'timeline.marker', label: 'Add marker', category: 'Timeline', shortcut: 'M', run: (c) => c.addMarker() },
  { id: 'timeline.snapping', label: 'Toggle snapping', category: 'Timeline', shortcut: 'N', run: (c) => c.toggleSnapping() },
  { id: 'layer.text', label: 'Add text layer', category: 'Layer', shortcut: 'T', run: (c) => c.addText() },
  { id: 'layer.shape', label: 'Add shape layer', category: 'Layer', run: (c) => c.addShape() },
  { id: 'layer.3d', label: 'Add 3D scene', category: 'Layer', run: (c) => c.addScene3D() },
  { id: 'playback.toggle', label: 'Play / Pause', category: 'Playback', shortcut: 'Space', run: (c) => c.togglePlayback() },
  { id: 'workspace.video', label: 'Switch to Video workspace', category: 'Workspace', run: (c) => c.setWorkspace('video') },
  { id: 'workspace.motion', label: 'Switch to Motion workspace', category: 'Workspace', run: (c) => c.setWorkspace('motion') },
  { id: 'workspace.3d', label: 'Switch to 3D workspace', category: 'Workspace', run: (c) => c.setWorkspace('3d') },
  { id: 'workspace.audio', label: 'Switch to Audio workspace', category: 'Workspace', run: (c) => c.setWorkspace('audio') },
  { id: 'file.import', label: 'Import media', category: 'File', shortcut: 'Ctrl+I', run: (c) => c.showImport() },
  { id: 'file.export', label: 'Export video', category: 'File', shortcut: 'Ctrl+E', run: (c) => c.showExport() }
];

export function findCommands(query: string): EditorCommand[] {
  const normalized = query.toLowerCase().trim();
  if (!normalized) return commands;
  return commands
    .map((command) => ({ command, score: [command.label, command.category, command.keywords ?? ''].join(' ').toLowerCase().includes(normalized) ? 1 : 0 }))
    .filter(({ score }) => score > 0)
    .map(({ command }) => command);
}
